<template>
  <div class="container mt-5">
    <div class="card p-4 shadow border-0" style="border-radius: 16px;">
      <h4 class="mb-4 fw-bold" style="color: #b03a45;">✏️ Edit Income</h4>

      <form @submit.prevent="handleUpdate">
        <div class="row">
          <!-- Type -->
          <div class="col-md-6 mb-3">
            <div class="bg-white p-3 rounded shadow-sm">
              <label class="form-label">Type *</label>
              <select v-model="form.type" class="form-select border-0" required>
                <option disabled value="">Select type</option>
                <option value="cash">Cash</option>
                <option value="gift">Gift</option>
                <option value="transfer">Transfer</option>
              </select>
            </div>
          </div>

          <!-- Amount -->
          <div class="col-md-6 mb-3">
            <div class="bg-white p-3 rounded shadow-sm">
              <label class="form-label">Amount *</label>
              <input type="number" class="form-control border-0" v-model="form.amount" step="0.01" required />
            </div>
          </div>

          <!-- Date -->
          <div class="col-md-6 mb-3">
            <div class="bg-white p-3 rounded shadow-sm">
              <label class="form-label">Date *</label>
              <input type="date" class="form-control border-0" v-model="form.date" required />
            </div>
          </div>

          <!-- Note -->
          <div class="col-md-6 mb-3">
            <div class="bg-white p-3 rounded shadow-sm">
              <label class="form-label">Note</label>
              <input type="text" class="form-control border-0" v-model="form.note" />
            </div>
          </div>

          <!-- CEO (User) -->
          <div class="col-md-6 mb-3">
            <div class="bg-white p-3 rounded shadow-sm">
              <label class="form-label">CEO *</label>
              <select v-model="form.user_id" class="form-select border-0" required>
                <option disabled value="">Select CEO</option>
                <option v-for="user in users" :key="user.id" :value="user.id">
                  {{ user.firstname }} {{ user.lastname }}
                </option>
              </select>
            </div>
          </div>

       
        </div>

        <!-- Submit -->
        <div class="text-end mt-4">
          <button type="submit" class="btn text-white px-4" style="background-color: #b03a45;">
            Update Income
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useToast } from 'vue-toastification'
import axios from '@/api'

const route = useRoute()
const router = useRouter()
const toast = useToast()

const id = route.params.id

const form = ref({
  type: '',
  amount: '',
  date: '',
  note: '',
  user_id: '',
  company_id: ''
})

const users = ref([])
const companies = ref([])


const fetchUsers = async () => {
  try {
    const res = await axios.get('/Financial/incomes/ceo-users')
    users.value = res.data.data || []
  } catch (err) {
    toast.error('Failed to load users')
  }
}
const fetchCompanies = async () => {
  try {
    const res = await axios.get('/companies')
    companies.value = res.data 
  } catch (err) {
    toast.error('Failed to load companies')
    console.error('Company fetch error:', err)
  }
}




const fetchIncome = async () => {
  try {
    const res = await axios.get('/Financial/incomes')
    const allIncomes = res.data.data.data || []
    const income = allIncomes.find(item => item.id == id)

    if (!income) {
      toast.error('Income not found')
      return
    }

    form.value = {
      type: income.type,
      amount: income.amount,
      date: income.date,
      note: income.note,
      user_id: income.user_id,
      company_id: income.company_id !== null ? Number(income.company_id) : ''
    }
  } catch (err) {
    toast.error('Failed to load income')
  }
}


const handleUpdate = async () => {
  try {
    await axios.put(`/Financial/incomes/${id}`, form.value)
    toast.success('Income updated successfully')
    router.push('/office-expenses')
  } catch (err) {
    toast.error('Failed to update income')
  }
}

onMounted(async () => {
  await fetchUsers()
  await fetchCompanies()
  await fetchIncome()
})
</script>

<style scoped>
.form-label {
  font-weight: bold;
  color: #b03a45;
}
</style>
